import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const prefix = process.env.REACT_APP_API_URL;

const LoginMobile = ({ history }) => {
  

  useEffect(() => {
    // alert(window.location.href);
    var str_url = window.location.href;
    var queryDict = {};
    window.location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        queryDict[item.split("=")[0]] = item.split("=")[1];
      });

    if (str_url.includes("username") && str_url.includes("password")) {
      const data = {
        email: queryDict["username"],
        password: str_url.split("password=")[1],
      };
      alert(data.email);
      alert(data.password);
    //   setLoading(true);
      let requestObj = {
        email: data.email,
        password: data.password,
      };
      axios
        .post(prefix + "/api/login_without_2fa", requestObj)
        .then((res) => {
        //   setLoading(false);
          localStorage.setItem("bgToken", res.data.accessToken);
          localStorage.setItem(
            "userType",
            res.data.user_type ? res.data.user_type : ""
          );
          localStorage.setItem(
            "profilepic",
            res.data.profile_pic ? res.data.profile_pic : ""
          );
          localStorage.setItem("login", true);
          // setLogin({})
          history.push("/ticket-list");
          // setLogin({})
        })
        .catch((err) => {
        //   setLoading(false);
          let message = "Something went wrong";
          if (err.response && err.response.data && err.response.data.message) {
            message = err.response.data.message;
          }
          toast.error(message, {
            position: "top-right",
          });
          console.log(err);
        });
    }
  }, []);

  if (localStorage.getItem("login")) {
    const { from } = {
      from: {
        pathname: "/",
      },
    };
    return <Redirect to={from} />;
  }

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default LoginMobile;
